// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    asn: [],
    count: 0
};

const slice = createSlice({
    name: 'asn',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET DEPARTMENT
        setInboundASN(state, action) {
            state.asn = action.payload;
        },
        setAsnCount(state, action) {
            state.count = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getInboundASN(queryString = '') {
    return async () => {
        try {
            const response = await axios.get('/inbound');
            dispatch(slice.actions.setInboundASN(response.data.data.data));
            dispatch(slice.actions.setAsnCount(response.data.count));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
